import { mainnet, optimism, arbitrum, base} from "viem/chains";

// TODO: read this from some other config
export const etherealChains = [
  mainnet,
  optimism,
  arbitrum,
  base,
];
